// removed by extract-text-webpack-plugin
module.exports = {"linkItem":"_1B8pf9RroahNtQCpGVcNkQ","text":"_1EuEkMJyrILVNPxJeAyVyt","linkEdit":"_3xF_zHpn6v_fbtLnxKns3D"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/linkItem/linkItem.scss
// module id = 420
// module chunks = 0